import * as THREE from "three";
import * as TWEEN from "@tweenjs/tween.js";
import exclamation from "images/IPX/NewYork/ipx_frenzinnewyork_icon_exclamation mark_02.png";
import bubble from "images/IPX/NewYork/ipx_frenzinnewyork_icon_bubblechat_01.png";

class NPC {
  constructor(model, interactionTarget = null) {
    this.model = model;
    this.interactionTarget = interactionTarget;

    this.name = null;
    this.status = "DEFAULT";
    this.textSet = [];
    this.fixed = true;
    this.detect = false;
    this.visible = true;
    this.dist = null;
    this.detectDist = 9;
    this.visibleBoundary = 100;
    this.panelAnimationDuration = 300;

    this.boundingBox = new THREE.Box3().setFromObject(model);
    this.modelHeight = (this.boundingBox.max.y - this.boundingBox.min.y) * 1;
    this.panelMap = new THREE.TextureLoader().load(bubble);
    this.panelMap.needsUpdate = true;
    this.panelMaterial = new THREE.SpriteMaterial({
      map: this.panelMap,
      transparent: true,
    });
    this.statusPanel = new THREE.Sprite(this.panelMaterial);
    this.statusPanel.renderOrder = 2;
    this.statusPanel.center = new THREE.Vector2(0.5, 0);
    this.statusPanel.position.set(
      model.position.x,
      model.position.y + this.modelHeight * 0.3,
      model.position.z,
    );
    this.statusPanel.scale.set(0, 0, 0);
    this.panelScale = 0.8;

    this.lastPosition = null;
    this.currentPosition = this.model.position.clone();
    this.isMoving = null;

    this.model.add(this.statusPanel);
    this.animationMixer = new THREE.AnimationMixer(this.model);
    this.animations = this.model.animations;

    this.walkAnimationIndex = 4;
    this.defaultAnimationIndex = 8;
    this.walkAnimation = null;
    this.defaultAnimation = null;

    this.setup();
  }

  setup() {}

  setAnimation() {
    if (this.defaultAnimation) {
      this.defaultAnimation.reset();
    }
    this.walkAnimation = this.animationMixer.clipAction(
      this.animations[this.walkAnimationIndex],
    );
    this.defaultAnimation = this.animationMixer.clipAction(
      this.animations[this.defaultAnimationIndex],
    );
    if (this.fixed) {
      this.defaultAnimation.play();
    }
  }

  changeStatus(status) {
    switch (status) {
      case "DEFAULT":
        this.panelMap = new THREE.TextureLoader().load(bubble);
        this.statusPanel.material.map = this.panelMap;
        break;
      case "QUEST":
        this.panelMap = new THREE.TextureLoader().load(exclamation);
        this.statusPanel.material.map = this.panelMap;
        break;
      default:
        break;
    }
  }

  detectTarget(target) {
    if (!target) return;

    this.dist = this.model.position.distanceTo(target.position);

    if (this.dist > this.detectDist && this.detect === true) {
      this.detect = false;
      this.hidePanel();
    } else if (this.dist <= this.detectDist && this.detect === false) {
      this.detect = true;
      this.showPanel();
    }

    // visible boundary check to reduce drawcall & triangles in scene
    if (this.dist > this.visibleBoundary && this.visible === true) {
      this.visible = false;
      this.model.visible = false;
    } else if (this.dist < this.visibleBoundary && this.visible === false) {
      this.visible = true;
      this.model.visible = true;
    }
  }

  showPanel() {
    const params = {
      currentValue: {angle: Math.PI / 2, scale: 0},
      previousValue: {angle: 0, scale: 0},
    };
    new TWEEN.Tween(params)
      .to(
        {currentValue: {angle: 0, scale: this.panelScale}},
        this.panelAnimationDuration,
      )
      .easing(TWEEN.Easing.Elastic.Out)
      .onUpdate(() => {
        const scale = params.currentValue.scale;
        this.panelMaterial.rotation = params.currentValue.angle;
        this.statusPanel.scale.set(scale, scale, scale);
        params.previousValue = params.currentValue;
      })
      .start();
  }

  hidePanel() {
    const params = {
      currentValue: {angle: 0, scale: this.panelScale},
      previousValue: {angle: 0, scale: 0},
    };
    new TWEEN.Tween(params)
      .to(
        {currentValue: {angle: Math.PI, scale: 0}},
        this.panelAnimationDuration,
      )
      .easing(TWEEN.Easing.Exponential.Out)
      .onUpdate(() => {
        const scale = params.currentValue.scale;
        this.panelMaterial.rotation = params.currentValue.angle;
        this.statusPanel.scale.set(scale, scale, scale);
        params.previousValue = params.currentValue;
      })
      .start();
  }

  checkMovement() {
    this.lastPosition = this.currentPosition;
    this.currentPosition = this.model.position.clone();

    if (this.currentPosition.distanceTo(this.lastPosition) === 0) {
      if (this.isMoving === false) return;
      this.isMoving = false;
      this.walkAnimation.fadeOut(0.5);
      this.defaultAnimation.reset();
      this.defaultAnimation.fadeIn(0.5);
      this.defaultAnimation.play();
    } else {
      if (this.isMoving === true) return;
      this.isMoving = true;
      this.defaultAnimation.fadeOut(0.5);
      this.walkAnimation.reset();
      this.walkAnimation.fadeIn(0.5);
      this.walkAnimation.play();
    }
  }

  chatMode() {
    if (this.status === "CHATTING") {
      this.status = "DEFAULT";
    } else {
      this.status = "CHATTING";
    }
  }

  update(dt) {
    this.detectTarget(this.interactionTarget);
    if (!this.fixed) {
      this.checkMovement();
    }
    this.animationMixer.update(dt);
  }
}

export default NPC;
